import React from "react";

import { useHistory } from "react-router-dom";
import moment from "moment";

const OrderDetail = () => {
  let history = useHistory();

  let order = history.location.state;

  return (
    <section
      className="content"
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="col-md-12 clearfix">
        <div className="card">
          <div className="header clearfix" style={{ borderRadius: "5px" }}>
            <div className="col-xs-12 col-sm-6">
              <h2>#{order.order_id} Nolu Sipariş</h2>
            </div>
            <div className="col-xs-12 col-sm-6 align-right">
              <button
                className="btn btn-primary waves-effect"
                onClick={() => history.goBack()}
              >
                Geri
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <div className="card">
          {order.order_state === 800 ? (
            <div
              className="header bg-red"
              style={{ borderRadius: 5, padding: 10 }}
            >
              <h2 style={{ textAlign: "center", marginTop: 15 }}>
                Sipariş Durumu :<span> Reddedildi</span>
              </h2>
              <span></span>
            </div>
          ) : order.order_state === 500 ? (
            <div className="header bg-prepare">
              <h2 style={{ textAlign: "center", marginTop: 15 }}>
                Sipariş Durumu :<span> Hazırlanıyor</span>
              </h2>
            </div>
          ) : order.order_state === 600 ? (
            <div className="header bg-blue">
              <h2 style={{ textAlign: "center", marginTop: 15 }}>
                Sipariş Durumu :<span> Müşteriye Gidiyor</span>
              </h2>
            </div>
          ) : order.order_state === 700 ? (
            <div className="header bg-deliver">
              <h2 style={{ textAlign: "center", marginTop: 15 }}>
                Sipariş Durumu :<span> Teslim Edildi</span>
              </h2>
            </div>
          ) : (
            <div className="header bg-green">
              <h2 style={{ textAlign: "center", marginTop: 15 }}>
                Sipariş Durumu :<span> Onay Bekliyor</span>
              </h2>
            </div>
          )}
        </div>
      </div>

      <div className="col-md-12 clearfix">
        <div className="card">
          <div
            className="header"
            style={{ borderRadius: "5px", padding: "10px" }}
          >
            <h2>Ürünler</h2>
          </div>
          <div className="body" style={{ textAlign: "center" }}>
            <table id="productdetail" className="table table-hover">
              <thead style={{ display: "contents" }}>
                <tr role="row">
                  <th>Ürün Adı</th>
                  <th>Porsiyon / Ek Ürün</th>
                  <th>Adet</th>
                  <th>Tutar</th>
                </tr>
              </thead>
              <tbody>
                {order.products.map((product, ind) => {
                  return (
                    <tr key={ind}>
                      <td>
                        <div>{product.name.tr}</div>
                      </td>
                      <td>
                        <div>
                          {product.displayInfo.options.tr.map((options) => {
                            return (
                              <>
                                <span>{options}</span>
                                <br />
                              </>
                            );
                          })}
                        </div>
                      </td>
                      <td>
                        <div>{product.count}</div>
                      </td>
                      <td>
                        <div>{product.totalPriceWithOption}</div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="col-md-12 clearfix" style={{ textAlign: "center" }}>
        <div className="card">
          <div
            className="header"
            style={{ borderRadius: "5px", padding: "10px" }}
          >
            <h2>Adres Bilgileri</h2>
          </div>
          <div className="body" style={{ padding: "10px" }}>
            <ul className="list-unstyled">
              <li>
                <p>
                  <b>Sipariş Tarihi : </b>
                  {moment(order.createdAt).format("L")}
                </p>
              </li>
              <li>
                <p>
                  <b>Müşteri Adı : </b> {order.client_name}
                </p>
              </li>
              <li>
                <p>
                  <b>Telefon : </b>
                  {order.client_phone_number}
                </p>
              </li>
              <li>
                <p>
                  <b>Adres : </b>
                  {order.delivery_address}
                </p>
              </li>
              <li>
                <p>
                  <b>Adres Açıklama : </b>
                  {order.delivery_address_description}
                </p>
              </li>
              <li>
                <p>
                  <b>Ödeme Şekli : </b>
                  {order.payment_method_text_tr}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderDetail;
